/**
 * @desc 权限信息
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<defs.appCenter.AppDomainRoleAggregateResponseDto>;
export function request(code: string, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/role/permission/${code}`, {
      method: "GET",

      ...options,
    }),
  );
}
